import PropTypes from 'prop-types';
import React from 'react';
import ToggleInput from './toggleInput';
import LayoutInput from './LayoutInput';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {countries, seasonTypes, systemTypes, temperatureFormat} from 'helpers/constants';
import {validateTemperatureCelsius, validateTemperatureFarenheit, fahrenheitToCelsius, celsiusToFahrenheit} from '../../helpers/temperatureHelper';


class TemperatureInput extends React.Component {
  static propTypes = {
    edit: PropTypes.bool,
    group: PropTypes.object.isRequired,
    dataChanged: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    disabledFields: PropTypes.array,
    analysis: PropTypes.object,
    dealer: PropTypes.object,
    pool: PropTypes.object,
  };


  state = {
    value: this.props.analysis.temperature,
  }

  componentWillReceiveProps(nextProps) {
    const {country} = this.props.dealer;

    if (country === countries.CA &&
      nextProps.analysis.season !== seasonTypes.closing && nextProps.analysis.season !== seasonTypes.outSeason &&
      nextProps.analysis.displayInputTemperature !== this.props.analysis.displayInputTemperature &&
      (!!nextProps.analysis.temperature || nextProps.analysis.temperature === 0)) {
      const newTemp = nextProps.analysis.displayInputTemperature === temperatureFormat.CELSIUS ?
        fahrenheitToCelsius(this.state.value) :
        celsiusToFahrenheit(this.state.value);

      this.props.dataChanged({key: 'temperature', value: newTemp});
    }else if (nextProps.analysis.temperature !== this.props.analysis.temperature) {
      this.setState({
        value: nextProps.analysis.temperature,
      });
    }
  }

  temperatureValidation = (val) => {
    const {country} = this.props.dealer;
    const {typeID} = this.props.pool;
    const {season, displayInputTemperature} = this.props.analysis;

    if (country === countries.US || displayInputTemperature === temperatureFormat.FARENHEIT) {
      return validateTemperatureFarenheit(val, typeID, season);
    }

    return validateTemperatureCelsius(val, typeID, season);
  };

  temperatureValidationMessage = () => {
    return (() => {
      const {country} = this.props.dealer;
      const {season, displayInputTemperature} = this.props.analysis;
      const {typeID} = this.props.pool;
      const temperatureModifier = country === countries.US || displayInputTemperature === temperatureFormat.FARENHEIT ? 'farenheit' : 'celsius';

      if (country === countries.CA && displayInputTemperature === temperatureFormat.CELSIUS) {

        if (typeID === systemTypes.swimspa) {
          return <FormattedMessage id='analysis.analysis.swimspas.celsius' />;
        }
        if (typeID === systemTypes.spa) {
          return <FormattedMessage id='analysis.analysis.spas.celsius' />;
        }

        if (season === seasonTypes.inSeason) {
          return <FormattedMessage id={'analysis.analysis.inSeason.' + temperatureModifier} />;
        }

        return season === seasonTypes.opening ?
          <FormattedMessage id={'analysis.analysis.springOpening.' + temperatureModifier} /> : '';
      }

      if (country === countries.US || displayInputTemperature === temperatureFormat.FARENHEIT) {
        if (!(typeID === systemTypes.pool || typeID === systemTypes.swimspa)) {
          return <FormattedMessage id='analysis.analysis.spas.farenheit' />;
        }

        if (season === seasonTypes.inSeason) {
          return <FormattedMessage id={'analysis.analysis.inSeason.' + temperatureModifier} />;
        }

        return season === seasonTypes.opening ?
          <FormattedMessage id={'analysis.analysis.springOpening.' + temperatureModifier} /> : '';
      }

    })();
  };


  toggleTemperature = (option) => {
    this.props.dataChanged({key: 'displayInputTemperature', value: option});
  }

  render() {
    const {analysis, dealer} = this.props;
    let {formatMessage} = this.props.intl;

    const options = [
      {value: temperatureFormat.CELSIUS, label: '°C'},
      {value: temperatureFormat.FARENHEIT, label: '°F'},
    ];

    if(dealer.country === countries.CA) {
      return <ToggleInput label={formatMessage({id: 'general.temperature'})}
            dataKey='temperature'
            key='temperature'
            value={this.state.value}
            dataChanged={this.props.dataChanged}
            editMode={this.props.edit}
            validate={analysis.chlorineDemandOnly ? () => true : this.temperatureValidation}
            required={!analysis.chlorineDemandOnly}
            validateMessage={this.temperatureValidationMessage()}
            group={this.props.group}
            disabled={this.props.disabledFields}
            type='number'
            toggleOptions={options}
            toggledValue={analysis.displayInputTemperature}
            toggleAction={this.toggleTemperature}
            />;
    }

    return <LayoutInput label={formatMessage({id: 'general.temperature'})}
            dataKey='temperature'
            key='temperature'
            value={this.state.value}
            dataChanged={this.props.dataChanged}
            editMode={this.props.edit}
            validate={analysis.chlorineDemandOnly ? () => true : this.temperatureValidation}
            required={!analysis.chlorineDemandOnly}
            validateMessage={this.temperatureValidationMessage()}
            type='number'
            group={this.props.group}
            disabled={this.props.disabledFields}/>;
  }
}

export default injectIntl(TemperatureInput);
